// extracted by mini-css-extract-plugin
module.exports = {"postsList":"Posts_postsList__2__mo","emptyPostsList":"Posts_emptyPostsList__CkU0M"};